export const checkPermissions = (userCompanySubscriptionType, allow) => {
  // if (allowedPermissions.length === 0) {
  //   return true;
  // }

  // return userPermissions.some(permission => allowedPermissions.includes(permission));
  if (
    typeof allow === "undefined" ||
    typeof allow === "string" ||
    allow.length === 0
  ) {
    return false;
  }

  return allow.some(
    subscriptionType => userCompanySubscriptionType === subscriptionType
  );
};
